import { getTenantRuntime } from '../../app/bootstrap/tenantRuntime';

// Local-development sign-in (backend: core/local_dev_auth.py). Dev builds only;
// production bundles never read or offer it, and the backend refuses it unless
// LINESIDE_LOCAL_DEV_AUTH=1 is set on a local process.
const STORAGE_KEY = 'lineside.localDevSession';
const listeners = new Set();

const apiBase = () => getTenantRuntime().apiBaseUrl;

export function readLocalDevSession() {
  if (!import.meta.env.DEV) return null;
  try {
    const session = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    if (!session?.access_token) return null;
    if (Number(session.expires_at || 0) * 1000 <= Date.now()) {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return session;
  } catch {
    return null;
  }
}

const notify = (session) => listeners.forEach((listener) => listener(session));

export function onLocalDevSessionChange(listener) {
  if (!import.meta.env.DEV) return () => {};
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Local profiles offered on the login page; empty when the backend has it off. */
export async function listLocalDevUsers() {
  if (!import.meta.env.DEV) return [];
  try {
    const response = await fetch(`${apiBase()}/api/local-dev/users`);
    if (!response.ok) return [];
    const payload = await response.json();
    return Array.isArray(payload?.users) ? payload.users : [];
  } catch {
    return [];
  }
}

export async function startLocalDevSession(userProfileId) {
  if (!import.meta.env.DEV) throw new Error('Local sign-in is only available in development builds.');
  const response = await fetch(`${apiBase()}/api/local-dev/session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_profile_id: userProfileId }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload?.detail || 'Local sign-in failed.');
  return storeLocalDevSession(payload);
}

/** Keep a local session the backend issued (sign-in picker or a workspace entry ticket). */
export function storeLocalDevSession(payload) {
  if (!import.meta.env.DEV) throw new Error('Local sign-in is only available in development builds.');
  const session = { access_token: payload.access_token, refresh_token: null, expires_at: payload.expires_at, user: payload.user };
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  notify(session);
  return session;
}

export function clearLocalDevSession() {
  if (!import.meta.env.DEV) return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage is optional.
  }
  notify(null);
}
